import React from 'react';

const ProgressBar = ({ currentStep, isStepComplete, goToStep }) => {
  const steps = [
    { number: 1, label: 'Alignment', substeps: ['National Priority/Paranoia', 'State Priority/Paranoia'] },
    { number: 2, label: 'Constitution Optimization', substeps: ['Constitution Check', 'Bulletproof Test'] },
    { number: 3, label: 'Tactical Strategies', substeps: ['Tactical Optimization'] },
    { number: 4, label: 'Practical Exercises', substeps: ['7 Interactive Exercises'] },
    { number: 5, label: 'Summary Report', substeps: ['Review & Email'] },
    { number: 6, label: 'Completion', substeps: ['Final Summary'] }
  ];

  const getStepStatus = (stepNumber) => {
    if (stepNumber === currentStep) return 'active';
    if (isStepComplete(stepNumber)) return 'completed';
    return 'pending';
  };

  const getProgressWidth = () => {
    if (currentStep === 1) return '0%';
    if (currentStep === 2) return '16.67%';
    if (currentStep === 3) return '33.33%';
    if (currentStep === 4) return '50%';
    if (currentStep === 5) return '83.33%';
    if (currentStep === 6) return '100%';
    return '0%';
  };

  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div className="progress-line">
          <div 
            className="progress-line-fill" 
            style={{ width: getProgressWidth() }}
          ></div>
        </div>
        
        {steps.map((step, index) => (
          <div 
            key={step.number} 
            className="progress-step"
            onClick={() => isStepComplete(step.number) ? goToStep(step.number) : null}
            style={{ cursor: isStepComplete(step.number) ? 'pointer' : 'default' }}
          >
            <div className={`step-number ${getStepStatus(step.number)}`}>
              {step.number}
            </div>
            <div className="step-label">
              {step.label}
            </div>
          </div>
        ))}
      </div>
      
      <div style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
        Step {currentStep} of 6: {steps[currentStep - 1]?.label}
      </div>
    </div>
  );
};

export default ProgressBar;
